import type { ReactNode } from 'react'
import { Box } from './Box.tsx'
import { Typography } from './generic.tsx'

export const TitleSubtitle = ({ title, subtitle, dataTa }: { title: ReactNode; subtitle?: ReactNode; dataTa?: string }) => {
	return (
		<Box flex col>
			<Typography variant='h2' data-ta={dataTa}>
				{title}
			</Typography>
			{subtitle && (
				<Typography variant='body2' color='textSecondary'>
					{subtitle}
				</Typography>
			)}
		</Box>
	)
}
